import {$fetch} from '@/plugins/Fetch'
// 公告消息通知
export default {
  methods: {
    // 获取消息列表
    getMessageLists (query) {
      return $fetch('notice/list', {
        method: 'GET',
        body: query,
      })
    },
    // 获取消息详情 notice/detail
    getMessageDetail (query) {
      return $fetch('notice/detail', {query})
    },
    // 获取未读消息数量
    getMessageCount (query) {
      return $fetch('notice/unread-count', {
        method: 'GET',
        body: query,
      })
    },
    // 变更外链阅读状态 notice/change-read-status
    changeMessageState (query) {
      return $fetch('notice/change-read-status', {
        method: 'POST',
        body: query,
      })
    },
    // 获取投诉建议详情
    getComplainSuggestDetail (query) {
      return $fetch('notice/complain_suggest_detail', {
        method: 'GET',
        body: query,
      })
    },
    // 回复投诉与建议
    replyComplainSuggest (query) {
      return $fetch('notice/complain_suggest_reply', {
        method: 'POST',
        body: query,
      })
    },
    // 删除投诉建议回复内容
    deleteComplainSuggestReply (query) {
      return $fetch('notice/complain_suggest_reply_delete', {
        method: 'POST',
        body: query,
      })
    },
    // 消息通知 - 一键已读
    changeMeassageAllRead (query = {}) {
      return $fetch('notice/all_read', {
        method: 'POST',
        body: query,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/modules/messageNotice.js